<template>
    <form class="input-panel" @submit.prevent="post_a_post">
        <textarea v-model="content" class="form-control text" :class="{ 'is-invalid': error_message === 'wrong' }"
            aria-label="聊天输入框" placeholder="输入消息，Enter 发送，Shift + Enter 换行"
            @keydown.enter.exact.prevent="post_a_post" @keydown.enter.shift.stop></textarea>
        <button type="submit" class="btn btn-primary send-btn">发送</button>
        <div class="input-meta">
            <span v-if="error_message === 'wrong'" class="error-text">请输入内容后再发送</span>
            <span v-else class="hint-text">支持文本消息</span>
        </div>
    </form>
</template>

<script>
import { ref } from "vue";

export default {
    name: "ChatRoomInput",
    setup(props, context) {
        const error_message = ref('');
        const content = ref('');

        const post_a_post = () => {
            error_message.value = '';
            const trimmed = content.value.trim();
            if (trimmed === "") {
                error_message.value = "wrong";
                return;
            }
            context.emit('post_a_post', trimmed);
            content.value = "";
        };

        return {
            content,
            post_a_post,
            error_message,
        };
    }
}
</script>

<style scoped>
.input-panel {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 10px;
    padding: 16px 18px;
    background: var(--app-surface-muted);
    border-top: 1px solid var(--app-border);
}

.text {
    min-height: 54px;
    max-height: 150px;
    resize: vertical;
    padding: 14px;
    color: var(--app-text);
    font-size: 14px;
    line-height: 1.6;
    background: var(--app-surface-strong);
    border: 1px solid var(--app-border);
    border-radius: 14px;
    transition: border-color 0.2s, box-shadow 0.2s;
}

.text:focus {
    color: var(--app-text);
    background: var(--app-surface-strong);
    border-color: rgba(20, 184, 166, 0.55);
    box-shadow: 0 0 0 3px rgba(20, 184, 166, 0.16);
}

.send-btn {
    width: 92px;
    min-height: 54px;
    align-self: start;
    border-radius: 14px;
    box-shadow: 0 14px 24px rgba(37, 99, 235, 0.2);
}

.input-meta {
    grid-column: 1 / -1;
    min-height: 18px;
    margin-top: -2px;
}

.error-text {
    color: var(--app-danger);
    font-size: 13px;
    font-weight: 700;
}

.hint-text {
    color: var(--app-muted);
    font-size: 12px;
}

@media (max-width: 576px) {
    .input-panel {
        grid-template-columns: 1fr;
        padding: 14px;
    }

    .send-btn {
        width: 100%;
        min-height: 44px;
    }
}
</style>
